import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

export default function Footer() {
  return (
    <>
      {/* Dividing line with gradient */}
      <div className="h-px bg-gradient-to-r from-transparent via-brand-red to-transparent opacity-30"></div>
      
      <footer className="bg-[#0F1D4E] text-white relative overflow-hidden">
        {/* Subtle background pattern */}
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `url("https://readdy.ai/api/search-image?query=subtle%20fire%20safety%20pattern%20background%20with%20flame%20motifs%20and%20safety%20symbols%2C%20professional%20corporate%20texture%2C%20minimal%20geometric%20design%20in%20red%20and%20blue%20tones%2C%20very%20light%20and%20faint%20for%20footer%20overlay&width=1920&height=600&seq=footer-pattern&orientation=landscape")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-16">
            
            {/* Company Info with Enhanced Logo */}
            <div className="col-span-1 lg:col-span-2">
              {/* Logo with contrast enhancement */}
              <div className="relative mb-8">
                <div className="absolute inset-0 bg-gray-400/90 backdrop-blur-sm rounded-2xl border border-white/10"></div>
                <div className="relative p-6 text-center">
                  <BrandLogo size="medium" className="text-white filter drop-shadow-lg" />
                </div>
              </div>
              
              <p className="text-gray-200 mb-8 text-lg leading-relaxed max-w-md">
                Leading provider of comprehensive fire safety solutions, equipment, and services. 
                Protecting lives and property with cutting-edge technology and expert knowledge.
              </p>
              
              {/* Social Media Links */}
              <div className="flex space-x-6">
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-[#E64A3C] transition-all duration-300 cursor-pointer min-h-[48px] w-[48px] flex items-center justify-center bg-white/5 rounded-full border border-white/10 hover:border-[#E64A3C]/50 hover:bg-[#E64A3C]/10" 
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-[#E64A3C] transition-all duration-300 cursor-pointer min-h-[48px] w-[48px] flex items-center justify-center bg-white/5 rounded-full border border-white/10 hover:border-[#E64A3C]/50 hover:bg-[#E64A3C]/10" 
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-[#E64A3C] transition-all duration-300 cursor-pointer min-h-[48px] w-[48px] flex items-center justify-center bg-white/5 rounded-full border border-white/10 hover:border-[#E64A3C]/50 hover:bg-[#E64A3C]/10" 
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
                <a 
                  href="#" 
                  className="text-gray-300 hover:text-[#E64A3C] transition-all duration-300 cursor-pointer min-h-[48px] w-[48px] flex items-center justify-center bg-white/5 rounded-full border border-white/10 hover:border-[#E64A3C]/50 hover:bg-[#E64A3C]/10" 
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:pl-8">
              <h4 className="text-xl font-bold mb-6 text-[#E64A3C] filter drop-shadow-sm">Quick Links</h4>
              <ul className="space-y-4">
                <li>
                  <Link 
                    to="/" 
                    className="text-gray-200 hover:text-[#E64A3C] transition-colors duration-300 cursor-pointer text-lg font-medium hover:translate-x-1 transform transition-transform inline-block"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-gray-200 hover:text-[#E64A3C] transition-colors duration-300 cursor-pointer text-lg font-medium hover:translate-x-1 transform transition-transform inline-block"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/products" 
                    className="text-gray-200 hover:text-[#E64A3C] transition-colors duration-300 cursor-pointer text-lg font-medium hover:translate-x-1 transform transition-transform inline-block"
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services" 
                    className="text-gray-200 hover:text-[#E64A3C] transition-colors duration-300 cursor-pointer text-lg font-medium hover:translate-x-1 transform transition-transform inline-block"
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contact" 
                    className="text-gray-200 hover:text-[#E64A3C] transition-colors duration-300 cursor-pointer text-lg font-medium hover:translate-x-1 transform transition-transform inline-block"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="lg:pl-8">
              <h4 className="text-xl font-bold mb-6 text-[#E64A3C] filter drop-shadow-sm">Contact Info</h4>
              <div className="space-y-5">
                <div className="flex items-start space-x-4">
                  <div className="min-h-[24px] w-[24px] flex items-center justify-center">
                    <i className="ri-map-pin-fill text-[#E64A3C] text-xl filter drop-shadow-sm"></i>
                  </div>
                  <span className="text-gray-200 text-lg leading-relaxed">
                    Industrial Area, Street 45, Building 12, Doha, Qatar
                  </span>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="min-h-[24px] w-[24px] flex items-center justify-center">
                    <i className="ri-phone-fill text-[#E64A3C] text-xl filter drop-shadow-sm"></i>
                  </div>
                  <span className="text-gray-200 text-lg font-medium">+974 5554 4093</span>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="min-h-[24px] w-[24px] flex items-center justify-center">
                    <i className="ri-mail-fill text-[#E64A3C] text-xl filter drop-shadow-sm"></i>
                  </div>
                  <span className="text-gray-200 text-lg font-medium">info@flameguardqa.com</span>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="min-h-[24px] w-[24px] flex items-center justify-center mt-1">
                    <i className="ri-time-fill text-[#E64A3C] text-xl filter drop-shadow-sm"></i>
                  </div>
                  <div className="text-gray-200 text-lg leading-relaxed">
                    <div className="font-medium">Sun-Thu: 8:00 AM - 6:00 PM</div>
                    <div className="text-[#E64A3C] font-semibold mt-1">24/7 Emergency Support</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-base font-medium">
              © 2024 FlameGuardQA Trading and Services. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-6 md:mt-0">
              <a 
                href="#" 
                className="text-gray-300 hover:text-[#E64A3C] text-base transition-colors duration-300 cursor-pointer font-medium"
              >
                Privacy Policy
              </a>
              <a 
                href="#" 
                className="text-gray-300 hover:text-[#E64A3C] text-base transition-colors duration-300 cursor-pointer font-medium"
              >
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-gray-300 hover:text-[#E64A3C] text-base transition-colors duration-300 cursor-pointer font-medium"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>

        {/* Enhanced WhatsApp Floating Button */}
        <a
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-8 right-8 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 z-50 min-h-[64px] w-[64px] flex items-center justify-center border-2 border-white/20 hover:scale-110 hover:shadow-green-500/25"
          aria-label="Contact us on WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </footer>
    </>
  );
}
